"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseInvoiceDataResponse = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _browsers = require("./browsers");

var _locale = require("./locale");

var _Logger = _interopRequireDefault(require("./Logger"));

var _responseParsers = require("./response-parsers");

/* eslint-disable import/prefer-default-export */
var getInvoiceNotes = function getInvoiceNotes(notes) {
  return new Promise(function (resolve, reject) {
    if (notes) {
      if (_browsers.isBrowser) {
        try {
          fetch(notes).then(function (response) {
            return response.json();
          }).then(resolve)["catch"](reject);
        } catch (error) {
          _Logger["default"].error("Notes '".concat(notes, "' could not be fetched"));

          _Logger["default"].error(error);

          reject(error);
        }
      } else if (_browsers.isNode) {
        if (!notes) {
          resolve();
          return;
        } // eslint-disable-next-line global-require


        var https = require('https');

        https.get(notes, function (res) {
          var data = [];
          res.on('data', function (chunk) {
            data.push(chunk);
          });
          res.on('end', function () {
            resolve(Buffer.concat(data).toString());
          });
        }).on('error', function (error) {
          _Logger["default"].error("Notes '".concat(notes, "' could not be fetched"));

          _Logger["default"].error(error);

          reject(error);
        });
      }
    } else {
      resolve();
    }
  });
};

var parseInvoiceDataResponse = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(data) {
    var _data, _data$merchant, notes;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _data = data;
            _data.merchant.email = _data.campaign.email;
            _data.merchant.phone = _data.campaign.phone;
            _data.chargeDate = new Date(data.chargeDate).toLocaleDateString((0, _locale.getLocaleFromLanguageCode)((0, _locale.getBaseLocale)(data.language)), {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            });

            if (data.customer) {
              _data.customer = (0, _responseParsers.cleanCustomerDataToFE)((0, _extends2["default"])({}, data.contact, data.customer, {
                language: (0, _locale.getBaseLocale)(data.language)
              }));
            }

            if (data.dueDate) {
              _data.dueDate = new Date(data.dueDate).toLocaleDateString((0, _locale.getLocaleFromLanguageCode)((0, _locale.getBaseLocale)(data.language)), {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
              });
            }

            _data.order = data.order;
            _data.order.dueDate = _data.dueDate;
            delete _data.dueDate;
            _context.prev = 9;
            _context.next = 12;
            return getInvoiceNotes((_data$merchant = data.merchant) === null || _data$merchant === void 0 ? void 0 : _data$merchant.notes);

          case 12:
            notes = _context.sent;

            if (notes) {
              _data.notes = JSON.parse(notes)[data.language];
            }

            _context.next = 18;
            break;

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](9);

          case 18:
            return _context.abrupt("return", _data);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 16]]);
  }));

  return function parseInvoiceDataResponse(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.parseInvoiceDataResponse = parseInvoiceDataResponse;